export default {
    name: 'positiveIntegerOnly',
    implementation: {
        bind(el) {
            const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
            const target = input || el;

            // keydown is intentionally NOT used — mobile virtual keyboards fire event.key = "Unidentified",
            // and keydown does not cover paste, drag, autocomplete, or voice input.
            // The input event is the single source of truth for all input methods.
            //
            // Cap at 16 digits (Number.MAX_SAFE_INTEGER). Beyond this JS loses integer precision.
            // DO NOT use this directive on fields that store identifiers, codes, or arbitrary strings —
            // it is strictly for numeric input that will be handled as a JS integer.
            target.addEventListener('input', () => {
                const sanitized = target.value.replace(/\D/g, '').replace(/^0+/, '').slice(0, 16);
                if (target.value !== sanitized) {
                    target.value = sanitized;
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        }
    }
}